module.exports = __webpack_public_path__ + "static/media/error-mark.32e741bb.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/error-mark.svg
 ** module id = 1271
 ** module chunks = 0
 **/